export const UPDATE_DRAFT_VARIABLES = {
  id: '',
  username: undefined,
  textBlocks: [],
  categories: [],
  status: '',
};
